module.exports = __webpack_public_path__ + "static/media/tonko_robert.bf259c97.jpeg";